export default __webpack_public_path__ + "static/media/phone.d90a6d23.png";